import { render, staticRenderFns } from "./sidebar.component.vue?vue&type=template&id=ed97d5b6&scoped=true&"
import script from "./sidebar.component.vue?vue&type=script&lang=js&"
export * from "./sidebar.component.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.component.vue?vue&type=style&index=0&id=ed97d5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed97d5b6",
  null
  
)

export default component.exports